const isRtlEnabled = enabled => {
  var _document$defaultView, _document$getElements;

  // if not, check if div='rtl' is available in Html tag
  return typeof document !== 'undefined' && (((_document$defaultView = document.defaultView) === null || _document$defaultView === void 0 ? void 0 : _document$defaultView.getComputedStyle(document.getElementsByTagName('html')[0], '').direction) === 'rtl' || ((_document$getElements = document.getElementsByTagName('body')[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.dir) === 'rtl');
};

export { isRtlEnabled as i };
//# sourceMappingURL=isRtlEnabled-DXSQ1gyT-C6zs_USs.js.map
